import React from 'react';
import { render } from 'react-dom';
import '@atlaskit/css-reset/dist/bundle.css';
import App from './App';

export default render(<App />, document.getElementById('root'))